<template>
  <mobile-responsive-shell title="Paiements réparations">
    <div class="pay-rep-wrap">
      <div class="t">
        <button type="button" class="btn btn-outline-secondary btn-sm me-1" @click="refresh"><i class="bi bi-arrow-clockwise"></i></button>
        <button type="button" class="btn btn-primary btn-sm" @click="$router.push({ name: 'mobile-payments-repairs-create' })"><i class="bi bi-plus-lg"></i> Nouveau</button>
      </div>
      <p v-if="!rows || !rows.length" class="text-muted text-center py-4">Aucun paiement.</p>
      <article v-for="(row, idx) in rows" :key="row.reference || idx" class="c">
        <div class="d-flex justify-content-between">
          <div>
            <div class="fw-bold">{{ row.reference }}</div>
            <div class="small text-muted">Rep. {{ row.repair_reference }}</div>
          </div>
          <div class="btn-group btn-group-sm">
            <button type="button" class="btn btn-outline-primary" @click="goD(row)"><i class="bi bi-eye"></i></button>
            <button type="button" class="btn btn-outline-secondary" @click="goE(row)"><i class="bi bi-pencil"></i></button>
            <button type="button" class="btn btn-outline-danger" @click="rm(row)"><i class="bi bi-trash"></i></button>
          </div>
        </div>
        <div class="small">{{ lab(row) }}</div>
        <div class="small mt-1">
          {{ row.date }}
          <span class="text-primary">{{ payMethod(row) }}</span>
          <span class="text-success fw-semibold">{{ fm(row.amount) }}</span>
        </div>
        <div v-if="row.remark" class="small text-muted mt-1">{{ row.remark }}</div>
      </article>
    </div>
  </mobile-responsive-shell>
</template>
<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
export default {
  components: { MobileResponsiveShell },
  computed: { ...mapGetters("paymentRepair", { rows: "getAll" }) },
  mounted() {
    this.$store.dispatch("paymentRepair/fetchAll");
  },
  methods: {
    fm(v) {
      return v == null || v === "" ? "—" : parseFloat(v).toFixed(2) + " DH";
    },
    lab(row) {
      if (row.payment && row.payment.customer) return (row.payment.customer.fullName || "") + " " + (row.payment.customer.society || "");
      if (row.repair && row.repair.customer) return row.repair.customer.fullName || "—";
      return "—";
    },
    payMethod(row) {
      if (row.payment && row.payment.paymentMethod) return row.payment.paymentMethod;
      return "—";
    },
    refresh() {
      this.$store.dispatch("paymentRepair/fetchAll");
    },
    goD(row) {
      this.$router.push({ name: "mobile-payments-repairs-details", params: { reference: row.reference } });
    },
    goE(row) {
      this.$router.push({ name: "mobile-payments-repairs-edit", params: { reference: row.reference } });
    },
    rm(row) {
      this.$confirm({
        message: "Supprimer ce paiement pour la reparation " + row.repair_reference + " ?",
        button: { no: "Non", yes: "Oui" },
        callback: (ok) => {
          if (ok) this.$store.dispatch("paymentRepair/destroy", row.reference);
        },
      });
    },
  },
};
</script>
<style scoped>
.pay-rep-wrap {
  min-height: 1px;
}
.t {
  margin-bottom: 0.75rem;
}
.c {
  background: #fff;
  border-radius: 12px;
  padding: 0.875rem 1rem;
  margin-bottom: 0.65rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(0, 0, 0, 0.06);
}
</style>
